import { times } from 'lodash';
import { OptionType } from '../../../../../../../../CommonComponents/OPL/Select/BaseSelect/types';

const IRA_EXHAUSTED_YEARS_MAX = 10;

export const YEAR_THRESHOLD = 2020;

export const POST_2020_OPTIONS = [
  {
    label: 'Calculate Automatically',
    value: 0,
  },
  {
    label: 'Custom Distribution',
    value: 1,
  },
];

export const getIraDistributionStartYearOptions = (
  yearInherited: number | null,
): OptionType<number>[] => {
  if (yearInherited === null) {
    return [];
  }

  if (yearInherited >= YEAR_THRESHOLD) {
    return times(IRA_EXHAUSTED_YEARS_MAX).map(offset => ({
      label: (yearInherited + offset).toString(),
      value: yearInherited + offset,
    }));
  }

  return times(2).map(offset => ({
    label: (yearInherited + offset).toString(),
    value: yearInherited + offset,
  }));
};
